
const filters = document.querySelector("#bop-filter");
const filtered = document.querySelector("#bop-filtered");
const reinitButtons = document.querySelectorAll(".reinitButton");

if (filters) {
    filters.addEventListener("input", filterOffers);
}


if (reinitButtons) {
    reinitButtons.forEach(function (e) {
        e.addEventListener("click", reinit);
    });
}

function reinit()
{
    document.getElementById("bop-filter").reset();

    const filtersElements = filtered.querySelectorAll(".bop-filter-element");
    filtersElements.forEach((e) => {
        e.classList.remove("hidden")
        e.classList.add("block")
    })

    synchronizeNoResultsDiv()
}

function filterOffers()
{
    let filtersArray = []

    const sizes = [...filters.querySelectorAll("#bop-filter input:checked, #bop-filter option:checked")].map(
        (n) => n.dataset.truc
    )

    const values = Array.prototype.map.call(sizes, (obj) => {
        filtersArray.push(obj)
    });

    const filtersElements = filtered.querySelectorAll(".bop-filter-element");
        filtersElements.forEach((e) => {
            e.classList.add("hidden")
            e.classList.remove("block")
    })

    synchronizeDivs(filtersArray)
    synchronizeNoResultsDiv()
}

function synchronizeDivs(filtersArray)
{
    let z = ''
    Array.prototype.map.call(filtersArray, (obj) => {
        if (obj !== undefined) {
            z += '.' + obj + ''
            if (obj === filtersArray[filtersArray.length - 1]) console.log('end', obj)
        }
    });

    // Créer un string de classes à garder
    Array.prototype.map.call(filtersArray, (obj) => {
        let filteredElements = filtered.querySelectorAll(z);

        filteredElements.forEach((e) => {
            e.classList.remove("hidden")
            e.classList.add("block")
        })
    });
}

function synchronizeNoResultsDiv()
{
    let filterede = document.getElementsByClassName("bop-filter-element");
    let a = 0

    Array.prototype.map.call(filterede,(e) => {
        if (e.classList.contains("block")) a++
    })

    const e = document.getElementById("filterNoResults");

    if (a === 0){
        e.classList.remove("hidden")
        e.classList.add("block")
    } else {
        e.classList.add("hidden")
        e.classList.remove("block")
    }
}


